// config.js

import { enI18n } from './i18nOverrides';

const baseOidc = {
  scopes: ['openid', 'profile', 'email'],
  useClassicEngine: true,
};

const baseFeatures = {
  showPasswordToggleOnSignInPage: true,
  hideSignOutLinkInMFA: false,
  rememberMe: false,
};

const transformUsername = (username, operation) => {
  if (operation === 'FORGOT_PASSWORD') {
    const isValidEmail = /^\S+@\S+\.\S+$/.test(username);
    if (!isValidEmail) {
      return '';
    }
  }
  return username;
};

const makeWidget = ({ issuer, clientId, redirectUri, extraI18n }) => ({
  issuer,
  clientId,
  redirectUri,
  ...baseOidc,
  i18n: { en: extraI18n || enI18n },
  features: baseFeatures,
  transformUsername
});

export default {
  localhost: {
    oidc: {
      ...baseOidc,
      issuer: 'https://ciamdev.freedomwholesale.com/oauth2/default',
      clientId: '0oa9mfj5gnKRdzFke1d7',
      redirectUri: 'http://localhost:3000/'
    },
    widget: makeWidget({
      issuer: 'https://ciamdev.freedomwholesale.com/oauth2/default',
      clientId: '0oa9mfj5gnKRdzFke1d7',
      redirectUri: 'http://localhost:3000/'
    }),
  },

  devConfig: {
    isProduction: false,
    environment: 'dev',
    oidc: {
      ...baseOidc,
      issuer: 'https://freedomwholesale.oktapreview.com/oauth2/default',
      clientId: '0oaa6u7uiteHqjmnH1d7',
      redirectUri: 'https://clientdevcf.freedomwholesale.com/Login/index.html'
    },
    widget: makeWidget({
      issuer: 'https://freedomwholesale.oktapreview.com/oauth2/default',
      clientId: '0oaa6u7uiteHqjmnH1d7',
      redirectUri: 'https://clientdevcf.freedomwholesale.com/Login/index.html'
    }),
  },

  testConfig: {
    isProduction: false,
    environment: 'test',
    oidc: {
      ...baseOidc,
      issuer: 'https://identitytest.freedomwholesale.com/oauth2/default',
      clientId: '0oaaj0ov0jP3khWki1d7',
      redirectUri: 'https://clienttestcf.freedomwholesale.com/Login/index.html'
    },
    widget: makeWidget({
      issuer: 'https://identitytest.freedomwholesale.com/oauth2/default',
      clientId: '0oaaj0ov0jP3khWki1d7',
      redirectUri: 'https://clienttestcf.freedomwholesale.com/Login/index.html'
    }),
  },

  uat: {
    isProduction: false,
    environment: 'uat',
    oidc: {
      ...baseOidc,
      issuer: 'https://identityuat.freedomwholesale.com/oauth2/default',
      clientId: '0oab0g5ff2nTX4hHw1d7',
      redirectUri: 'https://clientuatcf.freedomwholesale.com/Login/index.html'
    },
    widget: makeWidget({
      issuer: 'https://identityuat.freedomwholesale.com/oauth2/default',
      clientId: '0oab0g5ff2nTX4hHw1d7',
      redirectUri: 'https://clientuatcf.freedomwholesale.com/Login/index.html'
    }),
  },

  uatb: {
    isProduction: false,
    environment: 'uatb',
    oidc: {
      ...baseOidc,
      issuer: 'https://identityuat.freedomwholesale.com/oauth2/default',
      clientId: '0oac8wg0tutXe8rHV1d7',
      redirectUri: 'https://clientuatbcf.freedomwholesale.com/Login/index.html'
    },
    widget: makeWidget({
      issuer: 'https://identityuat.freedomwholesale.com/oauth2/default',
      clientId: '0oac8wg0tutXe8rHV1d7',
      redirectUri: 'https://clientuatbcf.freedomwholesale.com/Login/index.html'
    }),
  },

  prodConfig: {
    isProduction: true,
    environment: 'prod',
    oidc: {
      ...baseOidc,
      issuer: 'https://identity.freedomwholesale.com/oauth2/default',
      clientId: '0oa99a6ambPLraImc697',
      redirectUri: 'https://clientcf.freedomwholesale.com/Login/index.html'
    },
    widget: makeWidget({
      issuer: 'https://identity.freedomwholesale.com/oauth2/default',
      clientId: '0oa99a6ambPLraImc697',
      redirectUri: 'https://clientcf.freedomwholesale.com/Login/index.html'
    }),
  }
};